export default __webpack_public_path__ + "static/media/logo_final.1a3279d2.png";